import { render, staticRenderFns } from "./OverflowText.vue?vue&type=template&id=29564d26&scoped=true"
import script from "./OverflowText.vue?vue&type=script&lang=js"
export * from "./OverflowText.vue?vue&type=script&lang=js"
import style0 from "./OverflowText.vue?vue&type=style&index=0&id=29564d26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29564d26",
  null
  
)

export default component.exports